// @flow
import React, { PureComponent } from "react";
import { Prompt } from "react-router";

type Props = { isDirty: boolean, message: ?string | ?boolean };

export default class NavigationBlock extends PureComponent<Props> {
    componentDidUpdate() {
        if (this.props.isDirty === true) {
            window.onbeforeunload = /* istanbul ignore next */ () =>
                this.props.message;
        } else {
            window.onbeforeunload = undefined;
        }
    }

    componentWillUnmount() {
        window.onbeforeunload = undefined;
    }

    render() {
        const { isDirty, message } = this.props;
        if (message == null) return null;
        return <Prompt when={isDirty} message={message} />;
    }
}
